/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AiDeviceDataItemApi",
            "endpoint": "https://hh689uvzjg.execute-api.eu-central-1.amazonaws.com/staging",
            "region": "eu-central-1"
        },
        {
            "name": "DeviceDataItemApi",
            "endpoint": "https://q2znqa4c5e.execute-api.eu-central-1.amazonaws.com/staging",
            "region": "eu-central-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://nyofebceerawjkcexv5eubxesq.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-3ufatmccfnekblt2qa3jhnyaiq",
    "aws_cognito_identity_pool_id": "eu-central-1:5a35d7df-89f0-42bd-b70c-4bcd0e8500a9",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_IJg5LOlZI",
    "aws_user_pools_web_client_id": "33fsln9kh381h0osf4pagcg1fp",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS",
            "REQUIRES_UPPERCASE"
        ]
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "eu-central-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "AiAnalizeData-e22jjjbb4nd2zasg25zik55cim-staging",
            "region": "eu-central-1"
        },
        {
            "tableName": "DeviceData-e22jjjbb4nd2zasg25zik55cim-staging",
            "region": "eu-central-1"
        }
    ],
    "aws_user_files_s3_bucket": "itbridgesolution-storage-6f79aa70200048-staging",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
